/**
 * 電話番号を国番号付きの形式に変換
 * @param phoneNumber - 電話番号（例: 09012345678）
 * @param countryCode - 国番号（例: +81）
 * @param isMultilingualEnabled - 多言語設定が有効かどうか
 * @returns 国番号付き電話番号（例: +819012345678）
 */
export const formatPhoneNumberWithCountryCode = (
  phoneNumber: string,
  countryCode: string,
  isMultilingualEnabled: boolean
): string => {
  // OFFの場合は+81をデフォルトで付与
  const code = isMultilingualEnabled ? countryCode : '+81'

  return `${code}${phoneNumber}`
}

/**
 * 国番号付き電話番号から国番号と電話番号を分離
 * @param phoneNumberWithCode - 国番号付き電話番号（例: +819012345678）
 * @returns { countryCode: string, phoneNumber: string }
 */
export const parsePhoneNumberWithCountryCode = (
  phoneNumberWithCode: string
): { countryCode: string; phoneNumber: string } => {
  // +で始まる場合、国番号を抽出
  if (phoneNumberWithCode.startsWith('+')) {
    // 国番号は1〜4桁の数字
    const match = phoneNumberWithCode.match(/^(\+\d{1,4})(\d+)$/)
    if (match) {
      return {
        countryCode: match[1],
        phoneNumber: match[2]
      }
    }
  }

  // パースできない場合はデフォルト値を返す
  return {
    countryCode: '+81',
    phoneNumber: phoneNumberWithCode
  }
}
